"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContractListCollectionsResponseSchema = exports.AdminContractGetCollectionResponseSchema = exports.AdminContractCollectionIdPathParamsSchema = exports.AdminContractListCollectionsQueryParamsSchema = exports.AdminContractUpdateCollectionRequestSchema = exports.AdminContractCreateCollectionRequestSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const ProductCollectionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    image: zod_1.z.string().nullable(),
    videoUrl: zod_1.z.string().nullable(),
    shortDescription: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    description: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    rate: zod_1.z.number(),
});
exports.AdminContractCreateCollectionRequestSchema = ProductCollectionSchema.pick({
    name: true,
    videoUrl: true,
    description: true,
    image: true,
    shortDescription: true,
    rate: true,
});
exports.AdminContractUpdateCollectionRequestSchema = exports.AdminContractCreateCollectionRequestSchema;
exports.AdminContractListCollectionsQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema;
exports.AdminContractCollectionIdPathParamsSchema = zod_1.z.object({ collectionId: shared_1.UUIDSchema });
exports.AdminContractGetCollectionResponseSchema = zod_1.z.object({ collection: ProductCollectionSchema });
exports.AdminContractListCollectionsResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ collections: ProductCollectionSchema.array() });
